// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { setISODay as fn } from "../setISODay.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const setISODayWithOptions = convertToFP(fn, 3);

// Fallback for modularized imports:
export default setISODayWithOptions;
